/**
 * Shared waitlist configuration constants.
 *
 * The position offset inflates displayed waitlist positions for social proof.
 * For example, position 1 in the DB displays as position 978.
 */
export const WAITLIST_POSITION_OFFSET = 977;
